import React from "react";

export type ListRowProps = {
  label: React.ReactNode;
  px: (n: number) => number;
  onClick?: () => void;
  rightIcon?: React.ReactNode; // 필요 시 아이콘 교체
  disabled?: boolean;
  boldT?: boolean; // 빨간 텍스트 (옵션)
  style?: React.CSSProperties;
};

const ListRow: React.FC<ListRowProps> = ({
  label,
  px,
  onClick,
  rightIcon,
  disabled,
  boldT,
  style,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        width: "100%",
        height: px(52),
        padding: `0 ${px(16)}px`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: "#fff",
        border: "none",
        cursor: disabled ? "default" : "pointer",
        opacity: disabled ? 0.5 : 1,
        textAlign: "left",
        ...style,
      }}
    >
      <span
        style={{
          fontSize: px(16),
          fontWeight: 500,
          color: boldT ? "#404040" : "var(--neutral-400, #A3A3A3)",
        }}
      >
        {label}
      </span>

      {rightIcon ?? (
        <svg width={px(18)} height={px(18)} viewBox="0 0 24 24">
          <path
            d="M9 18l6-6-6-6"
            stroke="#9CA3AF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
      )}
    </button>
  );
};

export default ListRow;
